import { UserInfoService } from './../../shared-resources/services/user-info.service';
import {
  HttpErrorHandlerService,
  MessageType,
} from './../../shared-resources/services/http-error-handling.service';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ResetPasswordService } from '../services/reset-password';
import { setAdminResetPassword } from '../interfaces/reset-pass.interface';

@Component({
  selector: 'app-admin-reset-password',
  templateUrl: './admin-reset-password.component.html',
  styleUrls: ['./admin-reset-password.component.less'],
})
export class AdminResetPasswordComponent implements OnInit {
  public loading: boolean;
  public validateForm: FormGroup;
  public userName: string;
  public TOKEN: string;
  public accountActivated: boolean;
  public alreadyActivated: boolean;
  public activationError: boolean;
  public passwordVisible = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private resetpassService: ResetPasswordService,
    private httpMessage: HttpErrorHandlerService,
    private translate: TranslateService,
    private userService: UserInfoService,
    private activatedRoute: ActivatedRoute
  ) {}

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }

  resetPassword(): void {
    this.loading = true;
    if (this.validateForm.valid) {
      const setPasswordRequest: setAdminResetPassword = {
        username: this.userName,
        newPassword: this.validateForm.controls['password'].value,
        token: this.TOKEN,
        pwdSetType: 'RESET'
      };
      this.resetpassService.setAdminResetPassword(setPasswordRequest).subscribe(
        () => {
          this.loading = false;
          this.httpMessage.showTopFloatMessage(
            this.translate.instant('app.resetpassword.success'),
            MessageType.SUCCESS,
            this.translate.instant('app.label.success')
          );
          this.router.navigateByUrl('/login');
        },
        (error: any) => {
          this.httpMessage.showTopFloatMessage(
            error.error,
            MessageType.ERROR,
            this.translate.instant('app.label.error')
          );
          this.loading = false;
          this.validateForm.reset();
        }
      );
    } else {
      this.loading = false;
    }
  }
  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.userName = queryParams['username'];
    this.TOKEN = queryParams['token'];
    if (!this.userName) {
      this.router.navigateByUrl('/login');
      return;
    }
    this.validateForm = this.fb.group(
      {
        password: [null, Validators.compose([Validators.required])],
        cpassword: [null, Validators.compose([Validators.required])],
      },
      {
        validators: this.passwordMatchValidator,
      }
    );
  }

  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  passwordMatchValidator(control: AbstractControl): void {
    const password: string = control.get('password')?.value;
    const confirmPassword: string = control.get('cpassword')?.value;
    if (password !== confirmPassword) {
      control.get('cpassword')?.setErrors({ NoPassswordMatch: true });
    }
  }
}
